<template>
  <div ref="qrcode" class="qrcode_container"></div>
</template>

<script>
import Qrcode from 'qrcodejs2'
export default {
  name: 'QrCode',
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {}
  },
  mounted() {
    this.createQrcode()
  },
  methods: {
    createQrcode() {
      const _this = this
      this.qrcode = new Qrcode(this.$refs.qrcode, {
        text: _this.value,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: Qrcode.CorrectLevel.H,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.qrcode_container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 20px;
  width: 180px;
  height: 180px;
  ::v-deep img {
    width: 100%;
    height: auto;
    max-width: 300px;
  }
}
</style>
